import { styled } from '@linaria/react';
// intl-next Link не совместим с linaria. Не критично, при необходимости стилизовать дочерений <a> вместо Link
// eslint-disable-next-line no-restricted-imports
import Link from 'next/link';

import { MqTablet } from '~theme/media';
import { coverDiv, hoverable, truncateString } from '~theme/snippets';

export const Container = styled.div`
	position: relative;
	overflow: hidden;
	border-radius: var(--radius-xl);
	background-color: var(--color-white-xs);

	img {
		${coverDiv}
	}
`;

export const Shadow = styled.div`
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 80px;
	background-image: linear-gradient(transparent, var(--color-black-solid) 90%);
	opacity: 0.8;
`;

export const Inside = styled.div`
	position: relative;
	display: flex;
	height: 100%;
	flex-direction: column;
	justify-content: flex-end;
`;

export const StyledLink = styled(Link)`
	&::after {
		content: '';
		${coverDiv}
	}
`;

export const Button = styled.button`
	${hoverable}

	&::after {
		content: '';
		${coverDiv}
	}
`;

export const Title = styled.span`
	${truncateString}

	display: block;
	padding: 16px;
	font-size: var(--font-size-l);
	font-weight: var(--font-weight-medium);
	text-align: center;

	${MqTablet} {
		font-size: var(--font-size-xl);
	}
`;
